import type React from 'react';
import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { NOTICES_OF_CODE_VIOLATIONS } from '../../../constants';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function NoticesOfCodeViolations({ section, setSectionValues }: Props) {
  function onNoNotices(): void {
    setSectionValues({
      [NOTICES_OF_CODE_VIOLATIONS.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesNotices(): void {
    setSectionValues({
      [NOTICES_OF_CODE_VIOLATIONS.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onDescriptionChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [NOTICES_OF_CODE_VIOLATIONS.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  return (
    <FormField
      required
      label={
        <Label>
          In the past 12 months, have you received any notices of code violations or notices from municipalities or
          utility providers of utility termination?
        </Label>
      }
      control={
        <YesAndNoExpansion
          yesHandler={onYesNotices}
          noHandler={onNoNotices}
          yesActive={section.getFieldValue(NOTICES_OF_CODE_VIOLATIONS.FIELD_NAME.IS_ENABLED)}
        >
          <FormField
            required
            label={<Label>Describe these notices</Label>}
            control={
              <Textarea
                value={section.getFieldValue(NOTICES_OF_CODE_VIOLATIONS.FIELD_NAME.DESCRIPTION)}
                onChange={onDescriptionChange}
                css={{ resize: 'vertical' }}
                rows={3}
              />
            }
            description={
              <FormHelp>Later on, you will also have the ability to attach any notices to your lease</FormHelp>
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}

NoticesOfCodeViolations.description = 'Chicago specific screen';

export default NoticesOfCodeViolations;
